import { render, staticRenderFns } from "./Round.vue?vue&type=template&id=558c6de6&scoped=true&"
import script from "./Round.vue?vue&type=script&lang=js&"
export * from "./Round.vue?vue&type=script&lang=js&"
import style0 from "./Round.vue?vue&type=style&index=0&id=558c6de6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "558c6de6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('558c6de6')) {
      api.createRecord('558c6de6', component.options)
    } else {
      api.reload('558c6de6', component.options)
    }
    module.hot.accept("./Round.vue?vue&type=template&id=558c6de6&scoped=true&", function () {
      api.rerender('558c6de6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/wheel/Round.vue"
export default component.exports